import React, { ReactNode } from 'react'
import '../../styles/AdvisorCardsModule/AdvisorTag.scss'

interface AdvisorTagProps {
  children: ReactNode
  variant?: 'certification'
}

export const AdvisorTag = ({ children, variant }: AdvisorTagProps) => {
  const className = ['advisor-tag', variant && `advisor-tag--${variant}`].filter(Boolean).join(' ')
  return <span className={className}>{children}</span>
}
